import { css } from "@emotion/css";
import { Colors } from "@snapchat/snap-design-system";

import { appearingAnimation } from "../../../shared/styles";

export const detailsHeaderContainer = css`
    width: 100%;
    animation: ${appearingAnimation} 150ms ease;
`;

export const stringsContainer = css`
    flex: 1;
    width: 100%;
`;

export const shareLensButton = css`
    min-width: 114px;
    max-height: 32px;
    white-space: nowrap;
`;

export const copyButton = css`
    cursor: pointer;
    margin: 0 0 -2px 4px;
`;

export const removeLensButton = css`
    width: 32px;
    max-height: 32px;
    color: ${Colors.Black.V50} !important;
`;
